/**
 * Collapsible TS class for the Collapsible TCA-CE
 */
export class Collapsible
{

}

document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll<HTMLElement>(".collapsible .toggle-block");

    blocks.forEach(block => {
        const toggleButton = block.querySelector<HTMLElement>(".toggle-button");

        toggleButton?.addEventListener("click", () => {
            // Toggle open/closed state
            if (block.dataset.state === "open") {
                block.dataset.state = "closed";
            } else {
                block.dataset.state = "open";
            }
        });
    });
});
